import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Col, Container, Form, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux'
import { RootReducerState } from 'src/store/reducers'
import { useToast } from "src/components/Common/ReactToaster";
import CheckboxInput from 'src/components/UI/CheckboxInput'
import Button from 'src/components/UI/Button'
import ValidationPopup from 'src/components/Common/ValidationMessage/ValidationPopup'
import './Permission.scss'
import { TabPanel, TabView } from 'primereact/tabview'
import { clearPermissionMessage, getPermissionsLoading, getRolesLoading, updatePermissionsLoading } from 'src/store/permission/action'
import { Avatar } from 'primereact/avatar'
import { Accordion, AccordionTab } from 'primereact/accordion'
import ShowDialog from './AddUser'

function generateInitialValues(permissionDetails:any) {
  const initialValues:any = {};
  if (permissionDetails?.groups) {
      permissionDetails.groups.forEach((group:any) => {
          group.permissions.forEach((permission:any) => {
              initialValues[permission.name] = permission.isGranted;
          });
      });
  }
  return initialValues;
}

const PermissionPage = () => {
  const navigate = useNavigate()
  const { id } = useParams()


  // Inside your component
  const { error, loading, message, Roles, permissionDetails } = useSelector(
    (state: RootReducerState) => state.permissionReducer
  );

  const[selectedRole,setSelectedRole]=useState("admin")
  const { showToast } = useToast();
  const [visible, setVisible] = useState<any>()

  const dispatch = useDispatch();

  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }
  }, [loading]);

  const [EditMode, setEditMode] = useState(false)
  useEffect(() => {
    dispatch(getRolesLoading())
  }, []);





  const handleSubmit = async (values: any) => {
    let keys=Object.keys(values)
    let data={
      "permissions": keys?.map((item:any)=>({
        "name":item,
        "isGranted":values[item]
      }))
    }
    
    
    dispatch(updatePermissionsLoading(selectedRole,data))
  };

  const handleReset = (resetForm: any) => {
    setEditMode(false)
  }
  useEffect(() => {
    if (error) {
      setVisible(true)
    }
    if (message) {
      showToast(message, { type: "success" });
      dispatch(getPermissionsLoading(selectedRole))
      dispatch(getRolesLoading())
      setOpenModal(false)
      window.scrollTo({top:1})
      dispatch(clearPermissionMessage())
    }
  }, [error, message])
  const hidePopup = () => {
    setVisible(false);
    dispatch(clearPermissionMessage())
  }

  const dialogContainer = (error: any) => {
    return (
      <>
        <ValidationPopup error={error} visible={visible} onHide={hidePopup} />
      </>
    )
  }

  function capitalizeWords(string:any) {
    return string?.split(' ')?.map((word :any)=> word?.charAt(0)?.toUpperCase() + word?.slice(1))?.join(' ');
}

function getInitials(string:any) {
  const initials = string.match(/[A-Z]/g);
  return initials ? initials.splice(0,2).join('') : '';
}

let colors = [
  'linear-gradient(#33bfff, #007eb8)',
  'linear-gradient(#e5ccfd -34.88%, #7d2ae8)',
  'linear-gradient(#ffd6da -41.53%, #f84856)',
  'linear-gradient(#145DA0 -41.53%, #2E8BC0)',
  'linear-gradient(#EF7C8E -41.53%, #D8A7B1)',
  'linear-gradient(#167D7F -41.53%, #29A0B1)',
  'linear-gradient(#38668E -41.53%, #658891)',
  'linear-gradient(#0074B7 -41.53%, #003B73)',
  'linear-gradient(#2c3e50, #4ca1af)',
  'linear-gradient(#0f2027, #203a43, #2c5364)',
  'linear-gradient(#1e3c72, #2a5298)',
];
  const TabHeader = (options:any,role:any,index:any) => {
    let name=capitalizeWords(role.name)
    let initialLetter=getInitials(name)
    let color=colors[index]

    let style={ background: color, color: '#ffffff',marginRight:"10px",width:"24px",height:"24px" , fontWeight:"bolder"}
    return (
        <div className="flex align-items-center gap-2 p-3" style={{ cursor: 'pointer' }} onClick={()=>{options.onClick();setSelectedRole(role.name)}}>
           <Avatar label={initialLetter} size="normal" style={style} shape="circle" />
            <b className="font-bold white-space-nowrap">{String(name)}</b>
        </div>
    );
};

useEffect(()=>{
  
  dispatch(getPermissionsLoading(selectedRole))
  
},[selectedRole])

let [initialValues,setInitialValues]=useState<any>(null)
useEffect(()=>{

  let initialValues =  generateInitialValues(permissionDetails)
  setInitialValues(initialValues)
},[permissionDetails])


const handleChange = (e:any) => {
  const { name, checked } = e.target;
  setInitialValues((prevValues:any) => ({
    ...prevValues,
    [name]: checked
  }));
};

const handleFormSubmit = (e:any) => {
  e.preventDefault();
  handleSubmit(initialValues);
};
const [activeIndex, setActiveIndex] = useState<any>([0, 1, 2,3,4,5,6,,7,8,9,10,11,12,13]);


const[openModal,setOpenModal]=useState<boolean>(false)
  return (
      <React.Fragment>
            <div className='userpage' id="permission">
              <div className="d-flex justify-content-between align-items-center p-2">

              <h4 className='font-size-18'>Permission</h4>
              <Button
                className="btn-primary me-2"
                icon={"plus-circle"}
                onClick={()=>setOpenModal(true)}
                label="Add Role"
                type="submit"
              />
              </div>
              {openModal && <ShowDialog openModal={openModal} setOpenModal={setOpenModal}/>}
              {error && dialogContainer(error)}
                <Container fluid>
                    <div id="permission-view" className="permission_tabview">
                        <TabView scrollable>
                            {Roles.length > 0 && Roles.map((role:any, index:any) => (
                                <TabPanel header={role.name} headerTemplate={(options) => TabHeader(options, role, index)} key={index}>
                                    <div className=''>
                                      {initialValues && 
                                        // <Formik
                                        //     onSubmit={handleSubmit}
                                        //     initialValues={initialValues}
                                        //     enableReinitialize
                                        // >
                                        //     {({ values, handleChange, touched, errors, handleBlur, resetForm, setFieldValue, setFieldTouched, ...rest }) => (
                                                <Form onChange={handleChange} onSubmit={handleFormSubmit}>
                                                    <h4>{capitalizeWords(permissionDetails?.entityDisplayName)}</h4>
                                                    <div className='mb-3'>
                                                        <Accordion multiple  className='row' activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                                            {permissionDetails?.groups?.length > 0 && permissionDetails.groups.map((item:any, idx:any) => (
                                                                <AccordionTab header={item?.displayName} className='w-100' key={idx}>
                                                                    <b className='bold-text-parent'>{item?.displayName}</b>
                                                                    <div>
                                                                        {item?.permissions?.map((permission:any, pidx:any) => (
                                                                            <div key={pidx} className={permission.parentName ? 'margin-left-20' : 'border-parent'}>
                                                                           
                                                                                <CheckboxInput
                                                                                    name={String(permission.name)}
                                                                                    label={permission.displayName}
                                                                                    value={initialValues[String(permission.name)]}
                                                                                    onChange={handleChange}
                                                                                />
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </AccordionTab>
                                                            ))}
                                                        </Accordion>
                                                    </div>
                                                        <Row>
                                                            <Col lg={12} className='d-flex justify-content-end'>
                                                                            <Button
                                                                              className="secondary-btn me-2"
                                                                              label="Cancel"
                                                                              type="reset"
                                                                              onClick={() =>{dispatch(getPermissionsLoading(selectedRole))}}
                                                                            />
                                                                            <Button
                                                                              className="btn-primary me-2 btn-primary-shadow"
                                                                              label="Update"
                                                                              type="submit"
                                                                            />
                                                                          
                                                            </Col>
                                                            </Row>
                                                </Form>
//                                             )}
//                                         </Formik>
}
                                    </div>
                                </TabPanel>
                            ))}
                        </TabView>
                    </div>
                </Container>
            </div>
        </React.Fragment>
  )
}

export default PermissionPage